import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const ClassicBuildingOutline = createIcon({
  displayName: 'ClassicBuildingOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M10.5,21V17.66667A.66666.66666,0,0,1,11.16665,17h1.66667a.66667.66667,0,0,1,.66667.66667V21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17,21V11.4a2,2,0,0,0-.75061-1.56173l-3-2.4a2,2,0,0,0-2.49881,0l-3,2.4A2,2,0,0,0,7,11.40005V21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M21,21V5a1,1,0,0,0-1-1H4A1,1,0,0,0,3,5V21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="1.99999"
        y1="21"
        x2="21.99999"
        y2="21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M7.57224,10H3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M21,10H16.427"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.82262,11.02382l.00044-.00043a.24665.24665,0,1,1-.00044.00043"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const ClassicBuildingTwoTone = createIcon({
  displayName: 'ClassicBuildingTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" color="twoToneStrokeColor">
        <Box
          as="path"
          d="M17,21V11.4a2,2,0,0,0-.75061-1.56173l-3-2.4a2,2,0,0,0-2.49881,0l-3,2.4A2,2,0,0,0,7,11.40005V21"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <Box
          as="path"
          d="M10.5,21V17.66667A.66666.66666,0,0,1,11.16665,17h1.66667a.66667.66667,0,0,1,.66667.66667V21"
          fill="white"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M21,21V5a1,1,0,0,0-1-1H4A1,1,0,0,0,3,5V21"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="1.99999"
          y1="21"
          x2="21.99999"
          y2="21"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M7.57224,10H3"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M21,10H16.427"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <Box
          as="path"
          d="M11.82262,11.02382l.00044-.00043a.24665.24665,0,1,1-.00044.00043"
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </Box>
    </>
  ),
})

const ClassicBuilding: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={ClassicBuildingTwoTone} {...props} />
  default:
    return <CustomIcon as={ClassicBuildingOutline} {...props} />
  }
}

export default memo(ClassicBuilding)
